<template>
  <div class="ticket_shot">
    <div class="tips-box">
      交易快照包含订单创建时的展览描述和下单信息，买卖双方和平台在发生争议时，该页面作为判定依据。
    </div>
    <div class="swiper_box">
      <swiper :options="options" :activeIndex="activeIndex">
        <swiper-slide v-for="(m,i) in exhibit_detail.kv_imgs" :key="i" class="kv_img">
          <img class="img" :src="m" alt="">
        </swiper-slide>
      </swiper>
      <div class="dots" v-if="exhibit_detail.kv_imgs.length>1">{{ activeIndex }}/{{ exhibit_detail.kv_imgs.length }}</div>
    </div>
    
    <div class="exhibit-info">
      <div class="name">{{ exhibit_detail.name }}</div>
      <div class="date">{{ exhibit_detail.start_date | formatDate }} - {{ exhibit_detail.end_date | formatDate }}</div>

      <div class="address">
        <div class="address-name">{{ exhibit_detail.location }}</div>
        <div class="address-box">
          <img class="icon" src="https://res.paquapp.com/popmartvip/exhibitTicket/address_icon.webp"/>
        </div>
      </div>
    </div>
    <div class="grey-block"></div>
    <div class="ticket-info">
      <div class="left">已选</div>
      <div class="right">
        <div class="ticket-num">{{ exhibit_detail.skus[0].name }} 数量X{{ exhibit_detail.skus[0].buy_num }}</div>
        <div class="ticket-date">{{ exhibit_detail.skus[0].times }}</div>
      </div>
    </div>
    <div class="grey-block"></div>
    <div class="exhibit-desc">
      <div class="title">展览介绍</div>
      <div class="imgs">
        <img v-for="(img, i) in exhibit_detail.intro_imgs" :key="i" class="img" mode="widthFix" :src="img" lazy-load webp/>
      </div>
    </div>
  </div>
</template>

<script>
import apiGo from "./apiGo";
import service from './service'
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
let _this = null
export default {
  components: {
    swiper,
    swiperSlide
  },
  created() {
    _this = this;
    this.orderId = this.$route.query.orderId;
    this.openId = this.$route.query.openId;
    this.getShotDetail();
  },
  data() {
    return {
      exhibit_detail: {},
      activeIndex: 1,
      options: {
        on: {
          slideChange() {
            _this.activeIndex = this.activeIndex + 1;
          }
        }
      }
    };
  },
  filters: {
    formatDate(data) {
      let date = new Date(data);
      let YY = date.getFullYear() + '';
      let MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '';
      let DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + '';
      let result = `${YY}-${MM}-${DD}`;
      return result;
    }
  },
  methods: {
    getShotDetail() {
      let params = {
        order_no: this.orderId
      }
      params = service.creatSign(params)
      apiGo.getTicketShot(params).then(res => {
        if (res.code === 1) {
          this.exhibit_detail = res.data;
        }
      });
    },
    
  },
  
};
</script>

<style lang="scss" scoped>
.ticket_shot {
  .grey-block {
    width: 100vw;
    height: 16px;
    background: #F7F7F7;
  }
  .tips-box {
    color: #E60020;
    font-size: 22px;
    line-height: 1.4;
    padding: 16px 32px;
    background: #FDEBEE;
  }
  .swiper_box {
    width: 100vw;
    height: 750px;
    position: relative;
    .kv_img {
      width: 100vw;
      height: 750px;
      .img {
        width: 100%;
        height: 750px;
      }
    }
    .dots {
      font-size: 24px;
      color: #fff;
      width: 68px;
      height: 48px;
      border-radius: 24px;
      background: rgba(0, 0, 0, 0.3);
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      right: 32px;
      bottom: 24px;
      z-index: 1;
    }
  }
  
  .exhibit-info {
    padding: 48px 32px 0;
    background: #fff;
    .name {
      color: #111;
      font-size: 32px;
      font-weight: bold;
      line-height: 1.5;
      margin-bottom: 32px;
      word-break: break-all;
      word-wrap: break-word;
    }
    .date { 
      color: #999;
      font-size: 24px;
    }
    .address {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .address-name {
        color: #111;
        font-size: 24px;
        font-weight: bold;
      }
      .address-box {
        width: 280px;
        height: 140px;
        background: url('https://res.paquapp.com/popmartvip/exhibitTicket/address_bg.webp') no-repeat;
        background-size: cover;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .icon {
          width: 36px;
          height: 36px;
        }
      }
    }
  }
  .ticket-info {
    padding: 40px 32px;
    display: flex;
    .left {
      color: #999;
      font-size: 24px;
      width: 18%;
    }
    .right { 
      color: #111;
      font-size: 24px;
      .ticket-num {
        margin-bottom: 22px;
      }
      .ticket-date {

      }
    }
  }
  .exhibit-desc {
    background: #fff;
    padding-bottom: calc(env(safe-area-inset-bottom));
    .title {
      color: #111;
      font-size: 32px;
      font-weight: bold;
      padding: 40px 32px;
    }
    .imgs {
      width: 100vw;
      .img {
        display: block;
        width: 100%;
      }
    }
  }
}
</style>
